<ng-container *ngIf="iconName">
    <ion-icon [name]="iconName"></ion-icon>
</ng-container>
<ng-container *ngIf="iconPath">
    <img [src]="iconPath" width="50" height="50"/>
</ng-container>
<div class="icon-button-title" [innerHTML]="title"></div>
